import { render, staticRenderFns } from "./DefinitionDescription.vue?vue&type=template&id=730004fc&scoped=true&"
import script from "./DefinitionDescription.vue?vue&type=script&lang=ts&"
export * from "./DefinitionDescription.vue?vue&type=script&lang=ts&"
import style0 from "./DefinitionDescription.vue?vue&type=style&index=0&id=730004fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730004fc",
  null
  
)

export default component.exports